export default {
  key: 'customReportColumns',
  type: 'boolean',
  label: 'Custom report columns',
  description: "Add response counts by question type and your own calculated columns to the session report's Participants tab and Excel export",
  default: false,
  group: 'Reports',
}
